export default (that) => [
  {
    text: that.$l('menu_text_detail') || '查看详情',
    icon: 'el-icon-view',
    menuType: 'detail',
  },
  {
    text: that.$l('menu_text_edit') || '编辑单据',
    icon: 'el-icon-edit',
    menuType: 'edit',
    divided: true,
    allow: 'M',
    data: {},
    disabled: ({ amzFtyNoticeOutStatus }) => amzFtyNoticeOutStatus !== 'N',
  },
  {
    text: that.$l('menu_text_delete') || '删除单据',
    icon: 'el-icon-delete',
    menuType: 'delete',
    divided: false,
    allow: 'D',
    data: {},
    disabled: ({ amzFtyNoticeOutStatus }) => amzFtyNoticeOutStatus !== 'N',
  },
  {
    text: that.$l('menu_text_copy') || '复制单据',
    icon: 'el-icon-document-copy',
    menuType: 'copy',
    divided: true,
    allow: 'G',
    data: {},
    disabled: ({ amzFtyNoticeOutStatus }) => !['S','N'].includes(amzFtyNoticeOutStatus),
  },
  {
    text: that.$l('menu_text_generate') || '生成入库',
    icon: 'el-icon-document-add',
    menuType: 'generate',
    divided: true,
    allow: 'H',
    data: {},
    disabled: ({ amzFtyNoticeOutStatus }) => {
      return amzFtyNoticeOutStatus === 'D' || amzFtyNoticeOutStatus === 'Y'
    },
  },
  {
    text: that.$l('menu_text_send') || '通知送仓',
    icon: 'el-icon-message',
    menuType: 'send',
    divided: false,
    allow: 'S',
    data: {},
    disabled: ({ amzFtyNoticeOutStatus }) => amzFtyNoticeOutStatus !== 'N',
  },
  {
    text: that.$l('menu_text_confirm') || '送仓确认',
    icon: 'el-icon-chat-dot-square',
    menuType: 'confirm',
    divided: false,
    allow: 'F',
    data: {},
    disabled: ({ amzFtyNoticeOutStatus }) => amzFtyNoticeOutStatus !== 'S',
  },
  {
    text: that.$l('menu_text_cancel') || '取消出货',
    icon: 'el-icon-error',
    menuType: 'cancel',
    divided: false,
    allow: 'R',
    data: {},
    disabled: ({ amzFtyNoticeOutStatus }) => {
      return !(amzFtyNoticeOutStatus === 'S' || amzFtyNoticeOutStatus === 'F')
    },
  },
  {
    text: that.$l('menu_text_adjust') || '数据调整',
    icon: 'el-icon-edit-outline',
    menuType: 'adjust',
    divided: false,
    allow: 'C',
    data: {},
    disabled: ({ amzFtyNoticeOutStatus }) => {
      return !(amzFtyNoticeOutStatus === 'S' || amzFtyNoticeOutStatus === 'F')
    },
  },
  {
    text: that.$l('menu_text_print') || '打印标签',
    icon: 'el-icon-printer',
    menuType: 'printer',
    divided: true,
    allow: 'P',
    disabled: ({ amzFtyNoticeOutStatus }) => {
      return (
        amzFtyNoticeOutStatus !== 'S' &&
        amzFtyNoticeOutStatus !== 'F' &&
        amzFtyNoticeOutStatus !== 'Y'
      )
    },
  },
  {
    text: that.$l('menu_text_export') || '导出单据',
    icon: 'el-icon-right',
    menuType: 'export',
    divided: true,
    allow: 'E',
    data: { templateGroup: 'ecom-outboundNotice' },
    disabled: ({ amzFtyNoticeOutStatus }) => {
      return (
        amzFtyNoticeOutStatus !== 'S' &&
        amzFtyNoticeOutStatus !== 'F' &&
        amzFtyNoticeOutStatus !== 'Y'
      )
    },
  },
  {
    text: that.$l('menu_text_download') || '附件下载',
    icon: 'el-icon-download',
    menuType: 'download',
    divided: false,
    allow: 'X',
    data: {},
    disabled: ({ amzFtyNoticeOutStatus }) => {
      return (
        amzFtyNoticeOutStatus !== 'S' &&
        amzFtyNoticeOutStatus !== 'F' &&
        amzFtyNoticeOutStatus !== 'Y'
      )
    },
  },
]
